import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Table, Pagination, Button, Space, Dropdown, Menu, message , Modal, Input } from 'antd';
import { Card } from 'react-bootstrap';
import { DownloadOutlined, EditOutlined, EllipsisOutlined ,RollbackOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';

// Import Modal Components
import FundTransfer from "../createUserDistributer/fundTrnsfer/FundTrnasfer";
import SchemeManager from "../createUserDistributer/schemeManager/SchemeManager";
import IdStocks from "../createUserDistributer/IdsStoks/IdStoks";
import MemberPermission from "../createUserDistributer/memberPermission/MemberPermission";
import LockAmount from "../createUserDistributer/lockAmount/LockAmount";

import './distributor.css';
import {   reverseaepsPayment, reversePayment } from '../../../api/login/Login';

const DistributorList = ({
  loading,
  params,
  state,
  excelData,
  handleChange,
  onChangeVal,
  updateActiveStatus,
  getReailerDistIdAgainst
  ,submitForm,initialValues ,page
}) => {
  // Modal states
  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [error, setError] = useState(null);
  const [userMainWallet , setUserMainWallet] = useState(0)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true)

   const [isParentViewVisible, setIsParentViewVisible] = useState(false);
    const [parentRecord , setParentRecord] = useState([])
    const columnsParent = [
  
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Refer Id',
        dataIndex: 'refer_id',
        key: 'refer_id',
      },
      {
        title: 'Mobile',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      {
        title: 'Main Wallet',
        dataIndex: 'main_wallet',
        key: 'main_wallet',
      },
      {
        title: 'User Type',
        dataIndex: 'user_type',
        key: 'user_type',
      }
      
  
  
  
    ]

    const showParentView = (record)=>{
      // setSelectedUser(record)
  
      record?.length > 0 && record.sort((a , b)=> a.depth - b.depth)  
  
      setIsParentViewVisible(true);
      setParentRecord(record)
    }
  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true)
  const [show5, setShow5] = useState(false);
  const [reverseModalLoading, setReverseModalLoading] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [reversePaymentData, setReversePaymentData] = useState({
    userId: '',
    amount: '',
    remark: '',
    tpin: ''
  });
  const [aepsreverseModalLoading, setaepsReverseModalLoading] = useState(false);
  const [showaepsReverseModal, setaepsShowReverseModal] = useState(false);
  const [aepsreversePaymentData, setaepsReversePaymentData] = useState({
    userId: '',
    amount: '',
    remark: '',
    tpin: ''
  });


  const handleClose5 = () => setShow5(false);
  const [getItem, setGetItem] = useState()
  const handleShow5 = (item) => {
      setGetItem({ ...item, paramId: params?.id })
      setTimeout(() => {
          setShow5(true)
      }, 1000);
  }

  console.log("page",page)

  // Modal handlers
  // const handleLockAmount = (item) => {
  //   setSelectedItem({ ...item, paramId: params?.id });
  //   setShowLockAmount(true);
  // };

  const handleReverseModalOpen = (record) => {
  console.log(record , "Record")
  setUserMainWallet(record?.main_wallet)

    setReversePaymentData(prev => ({
      ...prev,
      userId: record._id
    }));
    setShowReverseModal(true);
  };

  const handleaepsReverseModalOpen = (record) => {
    console.log(record , "Record")
    setUserMainWallet(record?.main_wallet)
    setaepsReversePaymentData(prev => ({
      ...prev,
      userId: record._id
    }));
    setaepsShowReverseModal(true);
  };


  const handleReverseModalClose = () => {
    setUserMainWallet(0)
    setShowReverseModal(false);
    setReverseModalLoading(false);
    setReversePaymentData({
      userId: '',
      amount: '',
      remark: '',
      tpin: ''
    });
  };

  const handleaepsReverseModalClose = () => {
    setUserMainWallet(0)
    setaepsShowReverseModal(false);
    setaepsReverseModalLoading(false);
    setaepsReversePaymentData({
      userId: '',
      amount: '',
      remark: '',
      tpin: ''
    });
  };

  const handleaepsReversePaymentSubmit = async()=>{
    try {
      setaepsReverseModalLoading(true); // Show loader

      
      const response = await reverseaepsPayment(aepsreversePaymentData);
  
      if (response.statusCode === "200") {
        message.success(response?.data?.message || response?.message || 'Payment reversed successfully');
        handleaepsReverseModalClose(); // Close the modal
        // if (submitForm) {
        //   await submitForm(initialValues); 
        //   setReverseModalLoading(false);
        // }
        if (getReailerDistIdAgainst ) {
          await getReailerDistIdAgainst(page ? page : 0);
        }

      } else {
        message.error(response?.data?.message || response?.message || 'Failed to reverse payment');
      }
    } catch (err) {
      message.error(err?.data?.message || err?.message || 'Failed to reverse payment');
    } finally {
      setaepsReverseModalLoading(false); // Hide loader
    }
  }

  const handleReversePaymentSubmit= async () => {
    try {
      setReverseModalLoading(true); // Show loader
      const response = await reversePayment(reversePaymentData);
  
      if (response.statusCode === "200") {
        message.success(response?.data?.message || response?.message || 'Payment reversed successfully');
        handleReverseModalClose(); // Close the modal
        // if (submitForm) {
        //   await submitForm(initialValues); 
        //   setReverseModalLoading(false);
        // }
        if (getReailerDistIdAgainst ) {
          await getReailerDistIdAgainst(page ? page : 0);
        }

      } else {
        message.error(response?.data?.message || response?.message || 'Failed to reverse payment');
      }
    } catch (err) {
      message.error(err.data?.message || err?.message || 'Failed to reverse payment');
    } finally {
      setReverseModalLoading(false); // Hide loader
    }
  };
  
  const handleApprovalChange = (value, id) => {
    try {
      handleChange({ target: { value, name: 'is_approved' }}, id);
    } catch (err) {
      message.error('Failed to update approval status');
      setError('Failed to update approval status. Please try again.');
    }
  };

  const actionMenu = (record) => (
    <Menu>
      <Menu.Item key="1">
        <Link to={`/admin/certificate`}>BC Authorization Letter</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="#">ID Card</Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to="#">Certificate</Link>
      </Menu.Item>
      <Menu.Item key="4" onClick={() => handleShow()}>
        Fund Transfer / Return
      </Menu.Item>
      <Menu.Item key="5" onClick={() => handleShow2()}>
        Scheme
      </Menu.Item>
      <Menu.Item key="6" onClick={() => handleShow3()}>
        Add Id Stock
      </Menu.Item>
      <Menu.Item key="7" onClick={() => handleShow4()}>
        Permission
      </Menu.Item>
      <Menu.Item key="8" onClick={() => { handleShow5(record) }}>

        Locked Amount
      </Menu.Item>
      <Menu.Item key="9">
        <Link to="/admin/member/profile/view/3">View Profile</Link>
      </Menu.Item>
    </Menu>
  );

  const reportMenu = (record) => (
    <Menu>
      <Menu.Item key="1">
        <Link to={`/admin/statement/apes/report/${record._id}`}>AEPS</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to={`/admin/statement/billpayment/report/${record._id}`}>Billpayment</Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to={`/admin/statement/recharge/report/${record._id}`}>Recharge</Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link to={`/admin/statement/moneyTransfer/report/${record._id}`}>Money Transfer</Link>
      </Menu.Item>
      <Menu.Item key="5">
        <Link to="/admin/report/pancard/3">UtiPancard</Link>
      </Menu.Item>
      <Menu.Item key="6">
        <Link to="/admin/statement/report/2">Account Statement</Link>
      </Menu.Item>
      {/* <Menu.Item key="7">
        <Link to="/admin/statementwallet/report/2">Aeps Statement</Link>
      </Menu.Item> */}
      <Menu.Item key="9">
        <Link to={`/admin/aepswallets/report/${record._id}`}>AEPS Wallets Reports</Link>
      </Menu.Item>
      <Menu.Item key="8">
        <Link to={`/admin/wallets/report/${record._id}`}>Main Wallets Reports</Link>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: 'Serial No.',
      key: 'serial',
      render: (text, record, index) => {
        // Calculate the serial number based on currentPage and the index in the current page
        // const serialNo = index + 1 + currentPage * pageSize; // Assuming pageSize is the number of rows per page
        const serialNo = index + 1 
        return <span>{serialNo}</span>;
      },
    },
    {
      title: 'Name & Type',
      key: 'name',
      render: (text, record) => (
        <div>
          <div className="fw-bold">{record.name || '-'}</div>
          <small className="text-muted">{record.member_type || '-'}</small>
        </div>
      ),
    },
    {
      title: 'Reference Code',
      dataIndex: 'refer_id',
      key: 'refer_id',
      render: (text) => text || '-',
    },
    {
      title: 'Contact Info',
      key: 'contact',
      render: (text, record) => (
        <div>
          <div>{record.mobile || '-'}</div>
          <small className="text-muted">{record.email || '-'}</small>
        </div>
      ),
    },
    {
      title: 'Main Balance',
      dataIndex: 'main_wallet',
      key: 'main_wallet',
      render: (text) => <span>₹{text || '0'}</span>,
    },
    {
      title: 'Joining Date/Time',
      key: 'createdAt',
      render: (text, record) => (
        <div>
          <div>{record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : '-'}</div>
          <small className="text-muted">
            {record.createdAt ? moment(record.createdAt).format('HH:mm:ss') : '-'}
          </small>
        </div>
      ),
    },
      {
          title: params?.name?.toLowerCase() === 'reseller' ? 'Downline User' : 'View Parent',
          key: 'viewparent',
             render: (text, record) =>
            record?.member_type?.toLowerCase() === 'reseller' ? (
                <Link 
            to={`/admin/reseller-member-list/${record._id}`} 
            
          >

        
              <Button onClick={() => showParentView(record?.uplineChain)}>
                Downline User
              </Button>
                </Link>
            ) :  <Button
              
              onClick={() => showParentView(record?.uplineChain)}
            >
              View Parent
              </Button>,
        },

        {
          title: 'User Current Status ',
          key: 'status',
          render: (_, record) => (
            <button style={{minWidth:'100px'}} onClick={()=>updateActiveStatus(record)} className= {record?.status ? `btn btn-success`:`btn btn-danger ` }>
            {record?.status ? 'Active':"Deactive"}
            </button>
            
            
          ),
        },    
    {
      title: 'Status',
      key: 'is_approved',
      render: (text, record) => (
        <select
          className={`form-select form-select-sm ${record.is_approved ? 'border-success' : 'border-danger'}`}
          style={{width:'120px'}}
          value={record.is_approved?.toString() || "false"}
          onChange={(e) => handleApprovalChange(e.target.value, record._id)}
        >
          <option value="true">Approved</option>
          <option value="false">Not Approved</option>
        </select>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size="small" className="d-flex">
          <Dropdown overlay={actionMenu(record)} trigger={['click']}>
            <Button size="small" className="btn-action">
              Action <EllipsisOutlined />
            </Button>
          </Dropdown>
          <Dropdown overlay={reportMenu(record)} trigger={['click']}>
            <Button size="small" className="btn-report">
              Reports <EllipsisOutlined />
            </Button>
          </Dropdown>
          <Link 
            to={`/admin/create-user/${record._id}`} 
            className="btn btn-primary btn-sm"
          >
            <EditOutlined />
          </Link>
        </Space>
      ),
    },
    {
      title: 'Reverse Payment',
      key: 'reversePayment',
      render: (text, record) => (
        <Button 
          type="primary" 
          danger 
          icon={<RollbackOutlined />}
          onClick={() => handleReverseModalOpen(record)}
        >
          Reverse
        </Button>
      ),
     
    },
    ...(params?.name === 'Retailer' ? [{
      title: 'AEPS Reverse Payment',
      key: 'apesreversePayment',
      render: (text, record) => (
        <Button 
          type="primary" 
          danger 
          icon={<RollbackOutlined />}
          onClick={() => handleaepsReverseModalOpen(record)}
        >
          AEPS Reverse
        </Button>
      ),
    }] : [])
  ];
  



  const csvData = excelData?.user?.map(item => {
    // Assuming that `uplineChain` has all the roles (Distributor, Super Distributor, ASM, ZSM, etc.)
    const distributor = item.uplineChain.find(upline => upline.user_type === 'Distributor') || null;
    const superDistributor = item.uplineChain.find(upline => upline.user_type === 'Super Distributor') || null;
    const asm = item.uplineChain.find(upline => upline.user_type === 'asm') || null;
    const zsm = item.uplineChain.find(upline => upline.user_type === 'zsm') || null;
    
    // Create a map for all roles dynamically (expand as necessary)
    const roleMap = {
      'Distributor': distributor,
      'Super Distributor': superDistributor,
      'ASM': asm,
      'ZSM': zsm
    };
  
    // Return the user map with dynamic role fields
    return {
      Name: item.name || '',
      'Member Type': item.member_type || '',
      'Reference Code': item.refer_id || '',
      Mobile: item.mobile || '',
      Email: item.email || '',
      Balance: item.main_wallet || '0',
      'Joining Date': item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '',
      Status: item.is_approved ? 'Approved' : 'Not Approved',
      ...Object.keys(roleMap).reduce((acc, role) => {
        const roleData = roleMap[role];
        acc[`${role} Name`] = roleData ? roleData.name : 'N/A';
        acc[`${role} Refer ID`] = roleData ? roleData.refer_id : 'N/A';
        acc[`${role} Mobile`] = roleData ? roleData.mobile : 'N/A';
        acc[`${role} Main Wallet`] = roleData ? roleData.main_wallet : 'N/A';
        return acc;
      }, {}),
    };
  }) || [];

  return (
    <div className="m-4">
      <Card>
        <Card.Header className=" active-projects style-1">
          
          <div className="w-100 tbl-caption">
                  <h4 className="heading mb-0"><b>{params?.name || 'Distributor'} List</b></h4>
                  <div>
                   
                    <CSVLink 
                data={csvData} 
                filename={`${params?.name || 'distributor'}_list.csv`}
                className="btn btn-primary border border-white"
                style={{backgroundColor:'bs(--nav)'}}
              >
                <DownloadOutlined /> Download Excel
              </CSVLink>
                    
                  </div>
                </div>
        </Card.Header>
        <Card.Body className="p-0">
          {error && (
            <div className="alert alert-danger m-3">
              {error}
            </div>
          )}
          <Table
            columns={columns}
            dataSource={state?.user || []}
            rowKey={(record) => record?._id || Math.random()}
            loading={loading}
            pagination={false}
            className="custom-table"
            scroll={{ x: true }}
          />
          <div className="p-3 d-flex justify-content-between align-items-center">
            <div>
              Total {state?.totalCount || 0} entries
            </div>
            <Pagination
              total={state?.totalCount || 0}
              onChange={onChangeVal}
              showSizeChanger={false}
              current={page+1}
              showQuickJumper
              
            />
          </div>
        </Card.Body>
      </Card>

      {/* Modals */}
      <FundTransfer show={show} handleClose={handleClose} />
            <SchemeManager show2={show2} handleClose2={handleClose2} />
            <IdStocks show3={show3} handleClose3={handleClose3} />
            <MemberPermission show4={show4} handleClose4={handleClose4} />
            <LockAmount show5={show5} handleClose5={handleClose5} getItem={getItem} getReailerDistIdAgainst={getReailerDistIdAgainst} />


            {/* New Reverse Payment Modal */}
            <Modal
    title="Reverse Payment"
    open={showReverseModal}
    onCancel={handleReverseModalClose}
    // confirmLoading={reverseModalLoading}
    footer={[
      <Button key="cancel" onClick={handleReverseModalClose} disabled={reverseModalLoading}>
        Cancel
      </Button>,
      <Button 
        key="submit" 
        type="primary" 
        onClick={handleReversePaymentSubmit}
        loading={reverseModalLoading}
        disabled={
          !reversePaymentData.amount || 
          !reversePaymentData.remark.trim() || 
          !reversePaymentData.tpin.trim()
        }
        // disabled={
        //   !reversePaymentData.amount || // Check if amount is empty or zero
        //   !reversePaymentData.remark || // Check if remark is empty
        //   !reversePaymentData.tpin // Check if TPIN is empty
        // }
      >
        Submit
      </Button>,
    ]}
  >

    <p className='px-2'>Wallet Balance : {userMainWallet}</p>
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Input
        type="number"
        placeholder="Enter Amount"
        value={reversePaymentData.amount}
        onChange={(e) => setReversePaymentData(prev => ({ ...prev, amount: Number(e.target.value) }))}
        disabled={reverseModalLoading}
      />
      <Input
        placeholder="Enter Remark"
        value={reversePaymentData.remark}
        onChange={(e) => setReversePaymentData(prev => ({ ...prev, remark: e.target.value }))}
        disabled={reverseModalLoading}
      />
      <Input.Password
        placeholder="Enter TPIN"
        value={reversePaymentData.tpin}
        onChange={(e) => setReversePaymentData(prev => ({ ...prev, tpin: e.target.value }))}
        disabled={reverseModalLoading}
        autoComplete="new-password"
      />
    </Space>
  </Modal>


  {/* /// */}
  <Modal
    title="AEPS Reverse Payment"
    open={showaepsReverseModal}
    onCancel={handleaepsReverseModalClose}
    // confirmLoading={reverseModalLoading}
    footer={[
      <Button key="cancel" onClick={handleaepsReverseModalClose} disabled={aepsreverseModalLoading}>
        Cancel
      </Button>,
      <Button 
        key="submit" 
        type="primary" 
        onClick={handleaepsReversePaymentSubmit}
        loading={aepsreverseModalLoading}
        disabled={
          !aepsreversePaymentData.amount || 
          !aepsreversePaymentData.remark.trim() || 
          !aepsreversePaymentData.tpin.trim()
        }
        // disabled={
        //   !reversePaymentData.amount || // Check if amount is empty or zero
        //   !reversePaymentData.remark || // Check if remark is empty
        //   !reversePaymentData.tpin // Check if TPIN is empty
        // }
      >
        Submit
      </Button>,
    ]}
  >
      <p className='px-2'>Wallet Balance : {userMainWallet}</p>
    <Space direction="vertical" style={{ width: '100%' }} size="large">
    
      <Input
        type="number"
        placeholder="Enter Amount"
        value={aepsreversePaymentData.amount}
        onChange={(e) => setaepsReversePaymentData(prev => ({ ...prev, amount: Number(e.target.value) }))}
        disabled={reverseModalLoading}
      />
      <Input
        placeholder="Enter Remark"
        value={aepsreversePaymentData.remark}
        onChange={(e) => setaepsReversePaymentData(prev => ({ ...prev, remark: e.target.value }))}
        disabled={aepsreverseModalLoading}
      />
      <Input.Password
        placeholder="Enter TPIN"
        value={aepsreversePaymentData.tpin}
        onChange={(e) => setaepsReversePaymentData(prev => ({ ...prev, tpin: e.target.value }))}
        disabled={aepsreverseModalLoading}
        autoComplete="new-password"
      />
    </Space>
  </Modal>

   {
          isParentViewVisible && <>
           <Modal
          title="Parent Details"
          visible={isParentViewVisible}
          onOk={()=> setIsParentViewVisible(false)}
          onCancel={()=> setIsParentViewVisible(false)}
          centered
          width={800}
          footer={[
            <Button key="close" onClick={()=> setIsParentViewVisible(false)}>
              Close
            </Button>
          ]}
        >
           <Table
            columns={columnsParent}
            dataSource={parentRecord}
            rowKey="name"
            pagination = {false}
           >
  
           </Table>
         
        </Modal>
          
          </>
        }
    </div>
  );
};

export default DistributorList;